import { ClipboardList, Plus, RefreshCw, Search } from "lucide-react";
import { useEffect, useState } from "react";

import { CarregandoGrade } from "@/components/carregando";
import { Skeleton } from "@/components/ui/skeleton";

import CartaoComanda from "./CartaoComanda";
import { filtrarComandas } from "./lib";

/** Em fechamento (aguardando pagamento) primeiro, como em Mesas; depois por número. */
const ordem = (a, b) => (b.em_fechamento ? 1 : 0) - (a.em_fechamento ? 1 : 0) || a.numero - b.numero;

const GRADE = "grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-6 gap-3";

/** A grade das comandas abertas, com busca por nome ou número. `carregando` só
 * vale na primeira leitura (useComandas): o polling de 10 s não volta aos cards
 * cinza. */
export default function ListaComandas({ abertas, carregando, onNova, onRecarregar, ...acoes }) {
  const [busca, setBusca] = useState("");
  const [, tick] = useState(0);
  useEffect(() => { const i = setInterval(() => tick((x) => x + 1), 30000); return () => clearInterval(i); }, []);
  const lista = [...filtrarComandas(abertas, busca)].sort(ordem);
  return (
    <div className="p-4 sm:p-6" data-e2e="comandas-lista">
      <div className="max-w-7xl mx-auto space-y-4">
        <div className="flex flex-wrap items-center gap-3">
          <div className="min-w-0">
            <h1 className="text-2xl font-bold leading-tight">Comandas</h1>
            {carregando ? <Skeleton className="h-4 w-16 mt-1" /> : (
              <p className="text-sm text-muted-foreground">{abertas.length} {abertas.length === 1 ? "aberta" : "abertas"}</p>
            )}
          </div>
          <div className="ml-auto flex items-center gap-2">
            <button type="button" onClick={onRecarregar} aria-label="Atualizar" className="h-10 w-10 grid place-items-center rounded-lg border hover:bg-muted">
              <RefreshCw className={`w-4 h-4 ${carregando ? "animate-spin" : ""}`} />
            </button>
            <button type="button" onClick={onNova} data-e2e="comanda-nova"
              className="h-10 px-4 rounded-lg bg-primary text-primary-foreground font-semibold inline-flex items-center gap-2 hover:bg-primary/90">
              <Plus className="w-4 h-4" /> Nova comanda <kbd className="hidden sm:inline text-[10px] font-semibold px-1.5 py-0.5 rounded bg-primary-foreground/20">Enter</kbd>
            </button>
          </div>
        </div>

        <div className="relative max-w-md">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
          <input value={busca} onChange={(e) => setBusca(e.target.value)} placeholder="Buscar por nome ou número…" data-e2e="comanda-busca"
            className="w-full h-10 pl-9 pr-3 rounded-lg border bg-background text-sm outline-none focus:ring-2 focus:ring-primary/30" />
        </div>

        {!carregando && !abertas.length && (
          <div className="rounded-2xl border-2 border-dashed p-12 text-center">
            <ClipboardList className="w-10 h-10 mx-auto text-muted-foreground/40 mb-3" />
            <p className="font-semibold">Nenhuma comanda aberta</p>
            <p className="text-sm text-muted-foreground mt-1">Toque em <b>Nova comanda</b> para abrir a primeira. O nome do cliente é opcional.</p>
          </div>
        )}
        {!!abertas.length && !lista.length && <p className="text-sm text-muted-foreground">Nenhuma comanda com “{busca}”.</p>}
        {carregando ? <CarregandoGrade quantos={10} className={GRADE} altura="h-[250px]" /> : (
          <div className={GRADE}>
            {lista.map((c) => <CartaoComanda key={c.id} c={c} podeJuntar={abertas.length > 1} {...acoes} />)}
          </div>
        )}
      </div>
    </div>
  );
}
